import { componentClassName } from '@/styles/Footer';
import { Component, ComponentProps } from '@/types/component';
import { mergeProps } from '@/utils/mergeProps';

export type FooterListProps = ComponentProps<'ul'>;

export const FooterList: Component<FooterListProps> = ({ variant, size, colors, children, ...props }) => {
  const className = componentClassName('list', { variant, size, colors });

  return <ul {...mergeProps({ className }, props)}>{children}</ul>;
};
